import { useTacoConfigParameter } from '@coursera-web/taco-config-client';

import { isActivityInjectionEnabled } from '../utils';

export const TACO_NAMESPACE_INJECTABLE_ACTIVITIES_ROLLOUT_ALLOWLIST = 'injectable-activities/rollout-allowlist';
export const TACO_PARAMETER_INJECTABLE_ACTIVITIES_ENABLED_COURSE_IDS = 'enabledCourseIds';

/**
 * Hook to check if a given course is whitelisted for Proactive AI injection
 * (using TACO configuration). The hook also checks if the Epic feature flag is
 * enabled which is used to temporary guard development and testing of the
 * feature.
 *
 * @param courseId - The id of the course to check if injection is enabled for.
 * @returns Object with isEnabled boolean, loading state, and error.
 */
export const useIsInjectionEnabledForCourse = (
  courseId: string
): {
  isEnabled: boolean;
  loading: boolean;
  error?: string;
} => {
  const isFeatureEnabled = isActivityInjectionEnabled();
  const {
    data: enabledCourseIds,
    loading,
    error,
  } = useTacoConfigParameter<string[]>(
    TACO_NAMESPACE_INJECTABLE_ACTIVITIES_ROLLOUT_ALLOWLIST,
    TACO_PARAMETER_INJECTABLE_ACTIVITIES_ENABLED_COURSE_IDS
  );

  const isEnabled = isFeatureEnabled && (enabledCourseIds || []).includes(courseId);

  return { isEnabled, loading: isFeatureEnabled && loading, error };
};
